import { Component, Inject, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DermService } from 'src/app/includes/derm/derm.service';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-derm-menu',
  templateUrl: './derm-menu.component.html',
  styleUrls: ['./derm-menu.component.css']
})
export class DermMenuComponent implements OnInit {
  allDataSet: any[];
  currentUser: any;
  complaintForm: FormGroup;

  drugForms = ['cream', 'foam', 'gel', 'injection', 'lotion', 'ointment', 'oral', 'solution', 'wash'];
  lastUseOptions = ['still using', 'less than 1 week ago', '1 week ago', '2 weeks ago', '1 month ago', '3 months ago', '6 months ago', '1 year ago', 'more than 1 year ago'];
  responseOptions = ['improved significantly', 'improved slightly', 'no effect', 'worsened', 'not sure'];


  constructor(
    private dermService: DermService,
    private _authService: AuthService,
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<DermMenuComponent>,  
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.currentUser = this._authService.currentUser;
  }

  ngOnInit(): void {
    this.getAllDatasetofDerm();
    this.complaintForm = this.fb.group({
      isFollowUp: [null, Validators.required],
      followUpChange: [null],
      followUpProblem: [null],
      followedRecommendations: [null],
      problem: [null],
      otherProblem: [null],
      provisionalDiagnosis: [null],
      bodyParts: [null, Validators.required],
      frequency: [null, Validators.required],
      hasBiopsy: [null, Validators.required],
      biopsyResult: [null],
      hasMedication: [null, Validators.required],

      medicationName: [null],
      drugForm: [null],
      dosage: [null],
      medication_frequency: [null],
      duration: [null],
      lastUse: [null],
      response: [null],

      howLong: [null, Validators.required],
      otherSymptoms: [null],
      additionalInformation: [null],
      questions: [null],
      skinSymptoms: [null, Validators.required],
      symptoms: [null, Validators.required],

      hasMedications: [null],
      medications: [''],
      hasMedicalProblems: [null],
      medicalProblems: [''],
      hasAllergies: [null],
      allergies: [''],
      hasSkinCondition: [null],
      historyOfEczema: [''],
      historyOfMelanoma: [''],
      historyOfPsoriasis: [''],
      historyOfSkinCancer: [''],

    });

    this.complaintForm.patchValue(this.data?.main_derm||{});

    this.setupConditionalValidation();
  }

  async getAllDatasetofDerm(){
    const response:any = await this.dermService.getAllDataSet(this.currentUser.company_id).toPromise();
    if(response.status === 200){
      this.allDataSet = response.data;
      this.allDataSet.forEach((column)=>{
        column['expanded'] = false
      })
    }
  }
  expandColumn(columnIndex){
    this.allDataSet.forEach((column)=>{
      column['expanded'] = false
    });
    this.allDataSet[columnIndex].expanded = true;
  }

  setupConditionalValidation() {
    this.complaintForm.get('isFollowUp').valueChanges.subscribe(isFollowUp => {
      const followUpChange = this.complaintForm.get('followUpChange');
      const followUpProblem = this.complaintForm.get('followUpProblem');
      const followedRecommendations = this.complaintForm.get('followedRecommendations');
      const problem = this.complaintForm.get('problem');
      const otherProblem = this.complaintForm.get('otherProblem');
      const provisionalDiagnosis = this.complaintForm.get('provisionalDiagnosis');
      const additionalInformation = this.complaintForm.get('additionalInformation');

      if (isFollowUp) {
        followUpChange.setValidators([Validators.required]);
        followUpProblem.setValidators([Validators.required]);
        followedRecommendations.setValidators([Validators.required]);
        problem.clearValidators();
        provisionalDiagnosis.clearValidators();

        followedRecommendations.valueChanges.subscribe(value => {
          if (value === 'no' || value === 'partially') {
            additionalInformation.setValidators([Validators.required]);
          } else {
            additionalInformation.clearValidators();
          }
          additionalInformation.updateValueAndValidity();
        });
      } else {
        followUpChange.clearValidators();
        followUpProblem.clearValidators();
        followedRecommendations.clearValidators();
        problem.setValidators([Validators.required]);

        problem.valueChanges.subscribe(value => {
          if (value === 'Other') {
            otherProblem.setValidators([Validators.required]);
          } else {
            otherProblem.clearValidators();
          }
          otherProblem.updateValueAndValidity();
        });

        provisionalDiagnosis.setValidators([Validators.required]);
      }

      followUpChange.updateValueAndValidity();
      followUpProblem.updateValueAndValidity();
      followedRecommendations.updateValueAndValidity();
      problem.updateValueAndValidity();
      provisionalDiagnosis.updateValueAndValidity();
    });

    this.complaintForm.get('hasBiopsy').valueChanges.subscribe(hasBiopsy => {
      const biopsyResult = this.complaintForm.get('biopsyResult');
      if (hasBiopsy) {
        biopsyResult.setValidators([Validators.required]);
      } else {
        biopsyResult.clearValidators();
      }
      biopsyResult.updateValueAndValidity();
    });

    this.complaintForm.get('hasMedications')?.valueChanges.subscribe(value => {
      const medicalProblemsControl = this.complaintForm.get('medications');
      if (value === 'Yes') {
        medicalProblemsControl?.setValidators(Validators.required);
      } else {
        medicalProblemsControl?.clearValidators();
      }
      medicalProblemsControl?.updateValueAndValidity();
    });


    this.complaintForm.get('hasMedication')?.valueChanges.subscribe(value => {

      const medicationNameControl = this.complaintForm.get('medicationName');
      const drugFormControl = this.complaintForm.get('drugForm');
      const durationControl = this.complaintForm.get('duration');
      const lastUseControl = this.complaintForm.get('lastUse');
      const responseControl = this.complaintForm.get('response');

      if (value === 'Yes') {
        medicationNameControl?.setValidators(Validators.required);
        drugFormControl?.setValidators(Validators.required);
        durationControl?.setValidators(Validators.required);
        lastUseControl?.setValidators(Validators.required);
        responseControl?.setValidators(Validators.required);
      } else {
        medicationNameControl?.clearValidators();
        drugFormControl?.clearValidators();
        durationControl?.clearValidators();
        lastUseControl?.clearValidators();
        responseControl?.clearValidators();
      }
      medicationNameControl?.updateValueAndValidity();
      drugFormControl?.updateValueAndValidity();
      durationControl?.updateValueAndValidity();
      lastUseControl?.updateValueAndValidity();
      responseControl?.updateValueAndValidity();
    });


    this.complaintForm.get('hasMedicalProblems')?.valueChanges.subscribe(value => {
      const medicalProblemsControl = this.complaintForm.get('medicalProblems');
      if (value === 'Yes') {
        medicalProblemsControl?.setValidators(Validators.required);
      } else {
        medicalProblemsControl?.clearValidators();
      }
      medicalProblemsControl?.updateValueAndValidity();
    });

    // Validate `allergies` if `hasAllergies` is true
    this.complaintForm.get('hasAllergies')?.valueChanges.subscribe(value => {
      const allergiesControl = this.complaintForm.get('allergies');
      if (value === true) {
        allergiesControl?.setValidators(Validators.required);
      } else {
        allergiesControl?.clearValidators();
      }
      allergiesControl?.updateValueAndValidity();
    });

    // Validate history fields if `hasSkinCondition` is true
    this.complaintForm.get('hasSkinCondition')?.valueChanges.subscribe(value => {
      const historyOfEczemaControl = this.complaintForm.get('historyOfEczema');
      const historyOfMelanomaControl = this.complaintForm.get('historyOfMelanoma');
      const historyOfPsoriasisControl = this.complaintForm.get('historyOfPsoriasis');
      const historyOfSkinCancerControl = this.complaintForm.get('historyOfSkinCancer');

      if (value) {
        historyOfMelanomaControl.setValidators(Validators.required);
        historyOfPsoriasisControl.setValidators(Validators.required);
        historyOfSkinCancerControl.setValidators(Validators.required);
      } else {
        historyOfMelanomaControl.clearValidators();
        historyOfPsoriasisControl.clearValidators();
        historyOfSkinCancerControl.clearValidators();
      }
      historyOfMelanomaControl.updateValueAndValidity();
      historyOfPsoriasisControl.updateValueAndValidity();
      historyOfSkinCancerControl.updateValueAndValidity();
    });


  }

  onSubmit(): void {
    if (this.complaintForm.valid) {
      let formValues = this.complaintForm.value;
      let medications = formValues['medications'];
      if(medications && typeof medications == 'string') {
        medications =medications.split(',')?.map((item: string) => item.trim())||[];
      }
      formValues['medications'] = medications;
      this.dialogRef.close(formValues);
    } else {
      console.log('Form is invalid');
    }
  }

}

